import React from 'react'
import { Button, Row, Col } from 'antd'
import AgiliteHeader from '../../reusables/components/agilite-header'

const CoreRegisterConfirmation = () => (
  <div>
    <Row type='flex' justify='center'>
      <Col xs={23} sm={23} md={16} lg={12} xl={10} xxl={8}>
        <center>
          <AgiliteHeader
            header='Registration Submitted'
            subheader='Thank you for registering with Agilit-e. An email verification has been sent to your address'
          />
          <Button
            style={{
              backgroundColor: '#67AD5B',
              color: 'white',
              width: 'auto'
            }}
            onClick={e => {
              e.preventDefault()
              const port = window.location.port !== '' ? ':' + window.location.port : ''
              window.open(window.location.protocol + '//' + window.location.hostname + port, '_self')
            }}
          >
            Return Home
          </Button>
        </center>
      </Col>
    </Row>
  </div>
)

export default CoreRegisterConfirmation
